<template>
  <div v-loading="vloading">
    <el-form ref="form" label-width="120px" label-position="right">
      <template v-for="item in balanceList">
        <el-form-item :key="item.id" :label="balanceType(item.accountType)">
          <el-row :gutter="20">
            <el-col :span="16">
              <el-input
                placeholder="您当前最多可申请提现金额"
                disabled
                :value="item.totalAmount / 100"
              >
                <template slot="append"> 元 </template>
              </el-input>
            </el-col>
            <el-col :span="6">
              <el-button
                v-if="
                  item.accountType == 'BALANCE' &&
                    parentData.loginCode == parentData.datas.partyCode &&
                    parentData.partyType == 'PLAT_ADMIN'
                "
                type="primary"
                size="small"
                @click="withdrawal(item.totalAmount / 100)"
              >
                提现
              </el-button>
              <i
                v-if="
                  (item.accountType == 'TRADE_DEPOSIT' &&
                    parentData.loginCode == parentData.datas.partyCode &&
                    parentData.partyType == 'PLAT_ADMIN') ||
                    (item.accountType == 'TRADE_DEPOSIT' &&
                    parentData.loginCode == parentData.datas.partyCode &&
                    parentData.partyType == 'SHIPMENT') ||
                    (item.accountType == 'TRADE_DEPOSIT' &&
                    parentData.loginCode == parentData.datas.partyCode &&
                    parentData.partyType == 'SHIPMENT_COMPANY')
                "
                :class="finished ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"
                @click="depositInquiryClick"
              />
            </el-col>
          </el-row>
        </el-form-item>
      </template>
    </el-form>
    <vxe-table
      v-if="finished"
      border
      resizable
      stripe
      highlight-current-row
      show-footer
      show-overflow
      highlight-hover-row
      :data="tableList"
    >
      <vxe-table-column>
        <vxe-table-column
          field="chargeTime"
          title="入账时间"
          min-width="420"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="chargeTimeRange"
            type="daterange"
            value-format="yyyyMMdd"
            :picker-options="pickerOptions"
            :unlink-panels="true"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="(value) => changeDate(value)"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column field="totalAmount" title="入账金额" />
      <vxe-table-column field="maxRefundAmount" title="可退金额" />
      <vxe-table-column field="" title="操作">
        <template slot-scope="scope">
          <el-button
            type="primary"
            size="small"
            @click="depositDrawal(scope.row)"
          >提现</el-button>
        </template>
      </vxe-table-column>
    </vxe-table>
    <!-- <vxe-pager
      v-if="finished"
      :page-sizes="Pagingconf"
      :current-page.sync="deposit.pageNum"
      :page-size.sync="deposit.pageSize"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total',
      ]"
      @page-change="handlePageChange"
    /> -->
    <vxe-modal
      v-model="platFlag"
      title="余额提现"
      width="800"
      height="600"
      resize
    >
      <platCharge ref="platRef" :parent-data="parentData" @confirm="confirm" />
    </vxe-modal>
    <vxe-modal
      v-model="shipmentFlag"
      title="保证金提现"
      width="800"
      height="600"
      resize
    >
      <shipmentCharge ref="shipmentRef" @confirm="confirm" />
    </vxe-modal>
  </div>
</template>

<script>
function format(AddDayCount) {
  var dd = new Date();
  dd.setDate(dd.getDate() + AddDayCount); //获取AddDayCount天后的日期
  var y = dd.getFullYear();
  var m =
    dd.getMonth() + 1 < 10 ? "0" + (dd.getMonth() + 1) : dd.getMonth() + 1; //获取当前月份的日期，不足10补0
  var d = dd.getDate() < 10 ? "0" + dd.getDate() : dd.getDate(); //获取当前几号，不足10补0
  return y + "/" + m + "/" + d;
}
import { queryBalance, depositInquiry } from "@/api/InternetBanking";
import platCharge from "./components/platCharge.vue";
import shipmentCharge from "./components/shipmentCharge.vue";
export default {
  components: {
    platCharge,
    shipmentCharge,
  },
  // props: ['parentData'],
  props: {
    parentData: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      pickerOptions: {
        disabledDate: (time) => {
          let maxDate = new Date(this.maxDate);
          return time.getTime() > maxDate;
        },
      },
      platFlag: false,
      shipmentFlag: false,
      chargeTimeRange: [],
      deposit: {
        pageNum: 1,
        pageSize: 20,
        total: 0,
        startTime: "",
        endTime: "",
      },
      minDate: format(-90),
      maxDate: format(0),
      finished: false,
      tableList: [],
      vloading: false,
      balanceList: [],
      parent: {},
      partyCode: "",
    };
  },
  methods: {
    confirm() {
      this.platFlag = false;
      this.shipmentFlag = false;
      this.queryBalanceView(this.partyCode);
    },
    // 余额提现
    withdrawal(value) {
      let parent = {};
      parent.bankCardNo = this.parentData.datas.bankCardNo;
      parent.maxAmount = value;
      parent.phone = this.parentData.datas.contactMobile;
      this.platFlag = true;
      this.$nextTick(function () {
        this.$refs.platRef.init(parent);
      });
    },
    // 保证金提现
    depositDrawal(value) {
      let depositData = {};
      depositData.bankCardNo = this.parentData.datas.bankCardNo;
      depositData.refundAmount = value.maxRefundAmount;
      depositData.maxAmount = value.maxRefundAmount;
      depositData.phone = this.parentData.datas.contactMobile;
      depositData.relateOrderNo = value.orderNo;
      depositData.partyType = this.parentData.partyType;
      this.shipmentFlag = true;
      this.$nextTick(function () {
        this.$refs.shipmentRef.init(depositData);
      });
    },
    queryBalanceView(a) {
      const rLoading = this.openLoading();
      this.finished = false;
      this.partyCode = a;
      this.tableList = [];
      queryBalance(a)
        .then((response) => {
          this.balanceList = response.data;
          rLoading.close();
        })
        .catch((err) => {
          rLoading.close();
        });
    },
    //商户类型
    balanceType(type) {
      let value = "";
      switch (type) {
        case "BALANCE":
          value = "可用余额:";
          break;
        case "FREEZE":
          value = "冻结余额:";
          break;
        case "TRADE_DEPOSIT":
          value = "保证金余额:";
          break;
        default:
          value = "";
      }
      return value;
    },
    depositInquiryClick() {
      if (this.finished) {
        this.finished = false;
      } else {
        this.depositInquiryList();
      }
    },
    depositInquiryList() {
      this.vloading = true;
      depositInquiry(this.deposit)
        .then((response) => {
          this.tableList = response.data.records;
          this.deposit.total = response.data.total;
          response.data.total
            ? (this.Pagingconf = [20, 30, 50, 100, response.data.total])
            : (this.Pagingconf = [20, 30, 50, 100]);
          this.finished = true;
          this.vloading = false;
        })
        .catch((err) => {
          this.vloading = false;
        });
    },
    // 分页handle
    handlePageChange({ currentPage, pageSize }) {
      this.deposit.pageNum = currentPage;
      this.deposit.pageSize = pageSize;
      this.depositInquiryList();
    },
    changeDate(value, prefix) {
      if (value) {
        this.deposit.startTime = value[0];
        this.deposit.endTime = value[1];
      } else {
        (this.deposit.startTime = ""), (this.deposit.endTime = "");
      }
      this.depositInquiryList();
    },
  },
};
</script>

<style></style>
